import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Login from './components/Login/Login';

import Home from './pages/Home';
import Upload from './pages/Upload';
import Groupings from './pages/Groupings';
import GroupDetail from './pages/GroupDetail';
import Analysis from './pages/Analysis';
import Compare from './pages/Compare';
import RiskAnalysis from './pages/RiskAnalysis';

// Feature Flag
const ENABLE_RISK_ANALYSIS = process.env.REACT_APP_ENABLE_RISK_ANALYSIS === 'true';
const ENABLE_AUTH = process.env.REACT_APP_ENABLE_AUTH === 'true';

// Placeholder components for routes
// const Home = () => <div>Home Page</div>;
// const Upload = () => <div>Upload Page</div>;
// const Groupings = () => <div>Groupings Page</div>;
// const Analysis = () => <div>Analysis Page</div>;
// const Compare = () => <div>Compare Page</div>;

const PrivateRoute = ({ children }) => {
    // If auth is disabled, skip checks
    if (!ENABLE_AUTH) {
        return children;
    }

    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    // Basic session check (3 hours)
    const lastLoginTime = localStorage.getItem('lastLoginTime');
    const isSessionValid = lastLoginTime && (new Date() - new Date(lastLoginTime) < 3 * 60 * 60 * 1000);

    if (!isAuthenticated || !isSessionValid) {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('lastLoginTime');
        return <Navigate to="/login" />;
    }

    return children;
};

function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
                    <Route path="/upload" element={<PrivateRoute><Upload /></PrivateRoute>} />
                    <Route path="/groupings" element={<PrivateRoute><Groupings /></PrivateRoute>} />
                    <Route path="/groupings/:id" element={<PrivateRoute><GroupDetail /></PrivateRoute>} />
                    <Route path="/analysis" element={<PrivateRoute><Analysis /></PrivateRoute>} />
                    <Route path="/compare" element={<PrivateRoute><Compare /></PrivateRoute>} />
                    {ENABLE_RISK_ANALYSIS && (
                        <Route path="/risk-analysis" element={<PrivateRoute><RiskAnalysis /></PrivateRoute>} />
                    )}
                </Routes>
            </Layout>
        </Router>
    );
}

export default App;
